import { EventEmitter, Injectable } from '@angular/core';
import { Direction, Directionality } from '@angular/cdk/bidi';

@Injectable({ providedIn: 'root' })
export class CustomDirectionality extends Directionality {
  public override value: Direction = 'ltr';
  public override readonly change = new EventEmitter<Direction>();

  public setDirection(dir: Direction): void {
    if (this.value !== dir) {
      this.value = dir;
      this.change.emit(this.value);
    }
  }
}
